<template>
    <div class="piepagina">
        <small><a href="https://sised.com.co" target="_blank">Plataforma Sised</a> creada con <strong class="conamor"><b-icon-heart-fill></b-icon-heart-fill></strong>
         por: <a href="">binar10 SAS</a> &copy; {{ anno }}</small>
    </div>
</template>
<script>
    export default {
        data(){
            return{
                anno: null
            }
        },
        methods: {
            obtenerAnno(){
                var hoy = new Date()
                this.anno = hoy.getFullYear()
            }
        },
        created(){
            this.obtenerAnno()
        }
    }
</script>
<style scoped>
    .conamor{
        color: red;
    }
</style>